const Vue = require('vue')
const Sortable = require('sortablejs')
const { randstr } = require('sci/utils')
const R = require('ramda')
const $ = require('jquery')

const hackyWayToGetComponent = {}

Vue.component('sortable', {
    props: {
        source: {
            twoWay: true,
            default: {}
        },
        parent: {
            twoWay: true,
            default: {}
        },
        group: {
            type: String,
            default: null
        },
        handler: {
            type: String,
            default: null
        },
        draggable: {
            type: String,
            default: '>li'
        },
        filter: {
            type: String,
            default: '.undraggable'
        },
        onChanging: {
            type: Function,
            default: null
        },
        onChanged: {
            type: Function,
            default: null
        },
        onStart: {
            type: Function,
            default: null
        },
        sourceIdKey: {
            type: String,
            default: 'id'
        }
    },
    data () {
        return {}
    },
    ready () {
        this.vueId = randstr()

        this.$el.setAttribute('data-vue-id', this.vueId)

        hackyWayToGetComponent[this.vueId] = this

        this.bind()
    },
    methods: {
        bind () {
            const self = this

            if (this.sortable) {
                this.sortable.destroy()
            }

            this.sortable = Sortable.create(this.$els.list, {
                sort: false,
                group: this.group,
                filter: self.filter,
                draggable: self.draggable,
                handle: self.handler,
                scroll: document.querySelector('.scroll-root'),
                scrollSensitivity: 30,
                // Element dragging started
                onStart: function (evt) {
                    const id = evt.item.getAttribute('data-id')

                    const item = R.head(self.source.filter(_ => String(_[self.sourceIdKey]) === id))

                    if (self.onStart) {
                        self.onStart(item, self.parent)
                    }
                },
                onMove (evt) {
                    const target = hackyWayToGetComponent[evt.to.getAttribute('data-vue-id')]

                    const id = evt.dragged.getAttribute('data-id')

                    const item = R.head(self.source.filter(_ => String(_[self.sourceIdKey]) === id))

                    if (self.onChanging) {
                        self.onChanging(item, self.parent, target.parent)
                    }
                },
                onEnd (evt) {
                    let target
                    if (evt.item.parentElement) {
                        target = hackyWayToGetComponent[evt.item.parentElement.getAttribute('data-vue-id')]
                    } else {
                        target = self
                    }

                    const id = evt.item.getAttribute('data-id')

                    const item = R.head(self.source.filter(_ => String(_[self.sourceIdKey]) === id))

                    if (target.parent.status.id === item.form_status_id) {
                        return
                    }

                    if (self.onChanged) {
                        self.onChanged(item, target.parent)
                    }

                    // try {
                    //     evt.item.parentElement.removeChild(evt.item)
                    // } catch (ex) {}
                }
            })
        }
    },
    watch: {
        source () {
            this.bind()
        }
    },
    template: `
        <ul v-el:list>
            <slot></slot>
        </ul>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/sortable.js